module.exports = __webpack_public_path__ + "img/1501887981.204c1337.jpg";